module.exports = __webpack_public_path__ + "static/img/recruit_detail_pc.f35f0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/recruit_detail_pc.png
// module id = oFDQ
// module chunks = 1